import PropTypes from 'prop-types';
import SvgIcon from '../SvgIcon';

function Freeze({ className }) {
  return (
    <SvgIcon className={className}>
      <path d="M9.79419 2L9.79419 18" stroke="currentColor" />
      <path d="M7.79419 3L9.79419 5L11.7942 3" stroke="currentColor" />
      <path d="M11.7942 17L9.79419 15L7.79419 17" stroke="currentColor" />
      <path d="M2.86597 6L16.7224 14" stroke="currentColor" />
      <path d="M2.73206 8.23206L5.46411 7.5L4.73206 4.76795" stroke="currentColor" />
      <path d="M16.8563 11.7679L14.1243 12.5L14.8563 15.232" stroke="currentColor" />
      <path d="M16.7224 6L2.86601 14" stroke="currentColor" />
      <path d="M14.8563 4.76794L14.1243 7.5L16.8563 8.23205" stroke="currentColor" />
      <path d="M4.73206 15.2321L5.46411 12.5L2.73206 11.768" stroke="currentColor" />
    </SvgIcon>
  );
}

Freeze.propTypes = {
  className: PropTypes.string,
};

export default Freeze;
